/**
 * Shallow compares previous and new props and aborts the update if it's not required (they match).
 *
 * Due to the way menus are often updated by an external source, we want to make sure
 * that if someone passes a new menu definition that matches the previous one despite being a different object
 * we don't re-render the whole thing unnecessarily.
 *
 * Returns true if the prevProps and newProps are the same, false if the props are different.
 */
export function shallowCompareWithMenuDefinitionCheck<T extends object>(
  prevProps: T,
  nextProps: T
) {
  if (Object.keys(prevProps).length !== Object.keys(nextProps).length) {
    return false;
  }
  const keys = Object.keys(prevProps) as (keyof T)[];
  const differingProps = keys.filter((key: keyof T) => {
    if (!nextProps.hasOwnProperty(key)) {
      return true;
    }
    const areUnequalValues = prevProps[key] !== nextProps[key];
    if (
      (areUnequalValues && key === "deferredMenuDefinition") ||
      key === "menuDefinition"
    ) {
      // Deep compare
      return JSON.stringify(prevProps[key]) !== JSON.stringify(nextProps[key]);
    }
    return areUnequalValues;
  });
  return differingProps.length === 0;
}
